export default [
    {
        path: 'parametrizacao',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-parametrizacao' */
            '@/views/almoxarifado/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/index',
        children: [
            {
                name: 'almoxarifado-parametrizacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-parametrizacao' */
                    '@/views/almoxarifado/parametrizacao/Form.vue'
                ),
            },
        ],
    },
]